import { render, staticRenderFns } from "./NumberStat.vue?vue&type=template&id=21093594&"
import script from "./NumberStat.vue?vue&type=script&lang=js&"
export * from "./NumberStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21093594')) {
      api.createRecord('21093594', component.options)
    } else {
      api.reload('21093594', component.options)
    }
    module.hot.accept("./NumberStat.vue?vue&type=template&id=21093594&", function () {
      api.rerender('21093594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/dashboard/NumberStat.vue"
export default component.exports